import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { generateKey } from '@/utils';
import Image from '../ContentfulImage';
import Markdown from '../Markdown';
import Section from '../Section';
import media from '../../styles/media.style';

const TitleContainer = styled.div`
  ${media.tabletL`
    display: flex;
    justify-content: flex-end;
  `};
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: 500;
  line-height: 1.17;
  letter-spacing: 0.2px;

  ${media.tabletL`
    font-size: 38px;
    letter-spacing: 1.5px;
    width: 45%
  `};
`;

const Touts = styled.div``;

const Tout = styled.div`
  margin-top: 30px;

  ${media.tabletP`
    display: flex;
    justify-content: space-between;
  `};
`;

const ImageContainer = styled.div`
  ${media.tabletP`
    max-width: 450px;
    width: 45%;
  `};
`;

const Description = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px 0 0 0;

  ${media.tabletP`
    margin: 0;
    width: 45%;
  `};

  h1,
  h2,
  h3 {
    font-size: 14px;
    line-height: 1.29;
    letter-spacing: 0.1px;
    margin: 0;

    ${media.tabletL`
      font-size: 18px;
      font-weight: 500;
      line-height: 1.78;
      letter-spacing: 0.2px;
    `};
  }

  ul {
    padding-left: 20px;

    ${media.tabletL`
      padding-left: 0;
    `};
  }

  li {
    font-size: 14px;
    line-height: 1.29;
    letter-spacing: 0.1px;
    margin-top: 15px;
    white-space: pre-wrap;

    ${media.tabletL`
      font-size: 18px;
      line-height: 1.33;
    `};
  }
`;

const TopicToutSection = ({ entryId, title, touts }) => (
  <Section
    id={entryId}
    options={{ outer: { style: { paddingBottom: 50, paddingTop: 50 } }, content: { locked: true } }}
  >
    <TitleContainer>
      <Title>{title}</Title>
    </TitleContainer>

    <Touts>
      {touts &&
        touts.map((tout, index) => (
          <Tout key={generateKey('topic-tout-section', index)}>
            <ImageContainer>
              <Image src={tout.image} options={{ w: '100%', size: [450] }} />
            </ImageContainer>
            <Markdown src={tout.description} Component={Description} />
          </Tout>
        ))}
    </Touts>
  </Section>
);

TopicToutSection.defaultProps = {
  entryId: undefined,
  title: undefined,
  touts: undefined,
};

TopicToutSection.propTypes = {
  entryId: PropTypes.string,
  title: PropTypes.string,
  touts: PropTypes.arrayOf(PropTypes.shape()),
};

export default TopicToutSection;



// WEBPACK FOOTER //
// ./src/components/Article/TopicToutSection.js